import { Flex } from '@zillow/constellation';
import { FieldSet, Heading, Paragraph, Text } from '@zillow/constellation-10';

import MinCreditScoreFormField from '../FinancialExpectations/components/MinCreditScoreFormField';
import RMWPopover from '../../RMWPopover';
import { TYPES_MAP } from '../../../constants/ListingCriteriaConstants';
import listingCriteriaUtils from '../../../utils/listingCriteriaUtils';
import { useSelector } from '../../../selectors/useSelector';

const MinCreditScoreFormFieldContainer = () => {
  const currentCriteria = useSelector((state) => state?.properties?.currentProperty?.listingCriteria?.criteria);

  const getCriterion = (type: string) => listingCriteriaUtils.getCriteriaByType(currentCriteria, type);

  const creditScoreCriterion = getCriterion(TYPES_MAP.CREDIT_SCORE);

  const creditScoreMax = creditScoreCriterion.max;

  return (
    <FieldSet>
      <MinCreditScoreFormField
        label={
          <Flex display="flex" flexDirection="row" alignItems="center">
            <Text textStyle="body-sm-bold">Minimum credit score</Text>
            <RMWPopover
              tone="info"
              header={<Heading level={6}>Putting credit scores in context</Heading>}
              body={
                <Paragraph>
                  Credit scores fluctuate, and they don’t show a person’s history of timely rent payments. Consider
                  additional information, like income and landlord references, for a more complete understanding of an
                  applicant’s finances.
                </Paragraph>
              }
            />
          </Flex>
        }
        creditScoreMax={creditScoreMax}
      />
    </FieldSet>
  );
};

export default MinCreditScoreFormFieldContainer;
